// extracted by mini-css-extract-plugin
export var iconWrapper = "index-module--icon-wrapper--mjQJ8";
export var itemInner = "index-module--item-inner--e9dre";
export var label = "index-module--label--9JiLI";
export var link = "index-module--link--l++1t";
export var linkActive = "index-module--link-active--ilZEN";